import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Theme } from '@radix-ui/themes';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider } from '@mesa-labs/ui/components/Toast';
import queryClient from './lib/queryClient';
import router from './routes';
import { PORTAL_THEME_PROPS } from './theme';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Theme {...PORTAL_THEME_PROPS}>
        <ToastProvider>
          <Suspense fallback={null}>
            <RouterProvider router={router} />
          </Suspense>
        </ToastProvider>
      </Theme>
    </QueryClientProvider>
  );
}

export default App;
